export enum config {
    ENV = "prod"
}
